import $ from 'jquery';

$(function () {
    if ($('#float_down_page').length) {
        $('#execute').on('click', function () {
            $('#confirmation-dialog').removeClass('d-none');
        });

        $('#cancel').on('click', function () {
            $('#confirmation-dialog').addClass('d-none');
        });

        $('#confirm').on('click', function () {
            var url = $(this).data('link');

            $('#dialog-content').addClass('d-none');
            $('#dialog-loading').removeClass('d-none');

            $.post(url)
                .done(function (data) {
                    $('#buttons').addClass('d-none');
                    $('#message').replaceWith('<p>' + data.message + '</p>');
                    if (data.success) {
                    }
                })
                .fail(function (xhr, status, error) {
                    $('#buttons').addClass('d-none');
                    $('#message').text('Unable to send request: ' + xhr.status + '. Error: ' + JSON.stringify(error));
                })
                .always(function () {
                    $('#dialog-content').removeClass('d-none');
                    $('#dialog-loading').addClass('d-none');
                });;
        });
    }
});